<template lang="html">
  <div id="footer">

       <!-- <div class="appLoad">
            <div class="load-btn">下载华韵APP</div>
       </div> -->
       <div class="foot-text">
             <div class="foot-nav" v-show="getFooterShow!==1">
                  <div v-for="(item,index) in navs" :key="index" class="nav-item" @click="footSelect(index)">{{item}}</div>
             </div>
             <div @click="imgShow(0)" class="foot-line">京网文〔2020〕4369-781号</div>
             <div class="foot-line">京ICP备17020467号</div>
             <div class="foot-line">Copyright © 2019 中国音网</div>

             <div class="foot-line">京公网安备11010502039356号</div>
             <div @click="imgShow(1)" class="foot-line">计算机软件著作权登记书</div>
             <div @click="imgShow(2)" class="foot-line">中关村高新技术企业</div>
             <div @click="imgShow(3)" class="foot-line">实用新型专利证书</div>
             <div @click="imgShow(4)" class="foot-line">WSF认证</div>
             <div @click="imgShow(5)" class="foot-line">高新技术企业</div>
             <div @click="imgShow(6)" class="foot-line">中国版权协会常务理事单位</div>


       </div>

       <van-image-preview
           v-model="show"
          :lazy-load="true"
          :closeOnPopstate="true"
          :images="imgArr">
       </van-image-preview>

  </div>
</template>

<script>
export default {
    props:{
        getFooterShow: Number,
    },
     data(){
          return{
               navs:['唱片中心','戏曲','曲艺','歌曲','器乐','歌舞'],
               show:false,
               imgArr:[],
               imgCode:[
                  '3aa500f3b17c0c9400b13034e34d9f8d',
                  '2c9f23fc6eb17df9016eb4f5dea00529',
                  'e74ce08b77395be7d1e01d48d4a9a9e6',
                  '2c9f23fc6eb17df9016eb4f67374052f',
                  '2c9f23fc6eb17df9016eb4f699de0532',
                  '2c9f23fc6eb17df9016eb4f6cbb90535',
                  '2c9f23fc6eb17df9016eb4f6f6bf0538'
               ]
          }
     },
     methods:{
          footSelect:function(inx){
              if(inx == 0){
                  this.push('index')
              }else{
                  let urlArrs = [
                      { classId:1090,classText:'全部中国戏曲' },
                      { classId:1093,classText:'全部中国曲艺' },
                      { classId:1091,classText:'全部民族歌曲' },
                      { classId:1094,classText:'全部器乐音乐' },
                      { classId:1092,classText:'全部歌舞音乐' }
                  ]

                  let nowClass = urlArrs[inx - 1];
                  let query = {
                     classId:nowClass.classId,
                     classText:nowClass.classText,
                     postKey:'classifyList',
                     classType:1
                  };
                  this.push({
                       path:'seek',
                       query
                  });

                  if(this.$route.name == 'seek'){
                      this.$emit('goFrash');
                  }
              }

          },
          imgShow:function(inx){
              let url = 'http://image.china1896.com/' + this.imgCode[inx];
              this.imgArr = [];
              this.imgArr.push(url);
              this.show = true;
          }
     },
}
</script>

<style lang="css" scoped>

.appLoad{
     height: 90px;
     position: relative;
     display: flex;
     align-items: center;
     justify-content: space-around;
     background: white;
}

.load-btn{
     width: 142px;
     height: 40px;
     text-align: center;
     line-height: 42px;
     font-size: 15px;
     border-radius: 40px;
     background: #af2d2d;
     color: white;
}

.foot-text{
     padding: 20px 0;
}

.foot-nav{
    display: flex;
    margin: 0 12px;
    justify-content: space-between;
    margin-bottom: 12px;

}

.foot-line{
    font-size: 13px;
    text-align: center;
    margin-bottom: 6px;
    color: #666666;
}

</style>
